var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSelfExclusionIcon = function SvgSelfExclusionIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8E8E93",
    fillRule: "evenodd",
    d: "M12.5 9.5a4.5 4.5 0 1 1 9 0 4.5 4.5 0 0 1-9 0M17 3a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13m1.098 28H5.008c.231-6.114 5.26-11 11.431-11 2.37 0 4.227.479 5.506 1.332a1 1 0 0 0 1.11-1.664C21.335 18.52 19.045 18 16.439 18 9.017 18 3 24.017 3 31.439V32a1 1 0 0 0 1 1h14.098a1 1 0 0 0 0-2M37 29a8 8 0 1 1-16 0 8 8 0 0 1 16 0m-4.147-3.146a.5.5 0 0 0-.707-.708L29 28.293l-3.147-3.147a.5.5 0 0 0-.707.708L28.293 29l-3.147 3.146a.5.5 0 0 0 .707.707L29 29.707l3.146 3.146a.5.5 0 1 0 .707-.707L29.707 29z",
    clipRule: "evenodd"
  })));
};
export default SvgSelfExclusionIcon;